import fr from 'facet-rest';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';
import { PhoneMaskedTextInput } from 'Components/UI/MaskedInput';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import PasswordInput from 'Components/ComponentLibrary/Components/Inputs/Password';

const fieldsToHide = [
  'moduleName',
  'primaryText',
  'secondaryText',
  'title',
];

const BaseOverride = fr.metaOverride()
  .nameOverride(fieldsToHide, { hidden: true })
  .typeOverride('string', {
    _component: () => TextField,
  })
  .nameOverride('emailAddress', {
    _customProps: {
      InputProps: {
        name: 'email',
        id: 'email',
        type: 'email',
      },
    },
  })
  .nameOverride('password', {
    _component: () => PasswordInput,
    _customProps: {
      InputProps: {
        name: 'password',
        id: 'password',
      },
    },
  })
  .override({ hint: 'phoneNumber' }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: PhoneMaskedTextInput,
      },
    },
  })
  .typeOverride('number', {
    _customProps: {
      inputProps: {
        inputMode: 'decimal',
      },
    },
  })
  .typeOverride('picklist', { _component: () => SelectField })
  .typeOverride('multipicklist', { _component: () => SelectField })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .done();

export default BaseOverride;
